import { type Team } from "@entities";
import { type ColumnProps } from "@shared/frontend/hyper-table";

const columns: ColumnProps<Team>[] = [
  {
    field: "name",
    maxSize: undefined,
  },
  {
    field: "managers.manager.name",
    valueConverter: (team) =>
      (team.managers ?? [])
        .filter((m) => m.manager)
        .map((m) => m.manager?.name)
        .join(", "),
    caption: "מנהלים",
  },
  { field: "comments" },
];

export default columns;
